// extracted by mini-css-extract-plugin
export var container = "_cy-0";
export var infoIcon = "_cy-2";
export var titleRowCol = "_cy-1";